/**
 * Chinese translations for journey workflow action texts
 * Maps English action text to Chinese translation
 */

export const actionTranslations: Record<string, string> = {
  // Beginner Stage - Build Your Solution
  'Step 1: Define your core action - Write exactly what your tool does in this format: "My tool will [input] -> [output]." For example: "Take a blog post URL -> Return a social media post" or "Take a photo -> Return outfit suggestions." Keep it simple and specific.':
    '步骤 1：定义您的核心操作 - 用这种格式准确写出您的工具的功能："我的工具将 [输入] -> [输出]。" 例如："接收博客文章 URL -> 返回社交媒体帖子" 或 "接收照片 -> 返回服装建议。" 保持简单和具体。',
  
  'Step 2: Choose your building approach - Pick either: (A) No-code tools like Bubble.io or Softr for visual building, or (B) Code + AI assistants like Claude, ChatGPT, or Cursor for faster development. Choose based on your comfort level.':
    '步骤 2：选择您的构建方法 - 选择：(A) 无代码工具如 Bubble.io 或 Softr 进行可视化构建，或 (B) 代码 + AI 助手如 Claude、ChatGPT 或 Cursor 以加快开发速度。根据您的舒适度选择。',
  
  'Step 3: Build ONLY the core feature - Focus solely on your main input->output function. Skip user accounts, fancy design, settings pages, or extra features. Make it work first, make it pretty later.':
    '步骤 3：仅构建核心功能 - 专注于您的主要输入->输出功能。跳过用户账户、花哨的设计、设置页面或额外功能。先让它工作，再让它漂亮。',
  
  'Step 4: Deploy online - Put your tool on the internet where people can actually use it. Use platforms like Vercel, Netlify, Heroku, or your no-code platform\'s hosting. Get a simple URL that works.':
    '步骤 4：在线部署 - 将您的工具放到互联网上，让人们可以实际使用它。使用 Vercel、Netlify、Heroku 或您的无代码平台的托管服务。获取一个有效的简单 URL。',
  
  'Step 5: Create a simple landing page - Make a basic webpage with: (1) A clear headline explaining what your tool does, (2) A GIF or video showing it working, (3) An email signup form to capture interested users. Keep it simple and focused.':
    '步骤 5：创建简单的登陆页面 - 制作一个基本网页，包含：(1) 清晰的标题解释您的工具的功能，(2) 显示其工作原理的 GIF 或视频，(3) 电子邮件注册表单以捕获感兴趣的用户。保持简单和专注。',

  // Action Buttons
  'Create Market Survey': '创建市场调查',
  'Setup AI-Enhanced Pre-Release Project': '设置 AI 增强的预发布项目',
  'Generate Launch Assets': '生成发布资料',
  'Generate Ideas with AI': '使用 AI 生成创意',
  'Create Audience Survey': '创建受众调查',
  'Create Validation Survey': '创建验证调查',
  'Conduct User Research': '进行用户研究',
  'Post Team Request': '发布团队请求',

  // Have Idea Stage - Rapid Validation
  '💡 WHY VALIDATION MATTERS: Validation saves you from building the wrong thing. 42% of startups fail because there\'s no market need. Spend 1 week validating now to avoid wasting 6 months building later.':
    '💡 为什么验证很重要：验证可以避免您构建错误的东西。42% 的初创公司失败是因为没有市场需求。现在花 1 周时间验证，以避免以后浪费 6 个月的构建时间。',
  
  '📋 CRITICAL: Identify riskiest assumptions - List 5-7 assumptions your idea depends on (e.g., "People experience this problem weekly", "They would pay $X"), rank by risk (what would kill your idea if wrong?), select top 3 to test':
    '📋 关键：识别最危险的假设 - 列出您的想法所依赖的 5-7 个假设（例如，"人们每周都会遇到这个问题"，"他们会支付 $X"），按风险排序（如果错误会扼杀您的想法？），选择前 3 个进行测试',
  
  '📊 CRITICAL: Create Validation Survey - Generate AI-powered survey with 8-10 questions testing your top assumptions':
    '📊 关键：创建验证调查 - 生成包含 8-10 个问题的 AI 驱动调查，测试您的首要假设',
  
  '📝 IMPORTANT: Design survey questions - Include: (1) Problem frequency: "How often do you experience [problem]?", (2) Current solution: "How do you solve this today?", (3) Interest level: "Would you use a solution that [your idea]?", (4) Price sensitivity: "What would you pay?", (5) Alternatives: "What else have you tried?"':
    '📝 重要：设计调查问题 - 包括：(1) 问题频率："您多久经历一次 [问题]？"，(2) 当前解决方案："您今天如何解决这个问题？"，(3) 兴趣水平："您会使用解决 [您的想法] 的解决方案吗？"，(4) 价格敏感度："您会支付多少？"，(5) 替代方案："您还尝试过什么？"',
  
  '📢 CRITICAL: Share survey in 5+ channels - Post in: Reddit (r/[your niche]), Facebook groups, LinkedIn, Twitter/X, Discord servers, email to personal network. Aim for 20-30 responses minimum.':
    '📢 关键：在 5+ 渠道分享调查 - 发布到：Reddit（r/[您的领域]），Facebook 群组，LinkedIn，Twitter/X，Discord 服务器，电子邮件给个人网络。目标至少 20-30 个回复。',
  
  '📊 CRITICAL: Analyze results - Calculate: (1) Problem frequency: % who experience it weekly/daily, (2) Demand signal: % who said "definitely would use" (need ≥15%), (3) Price range: median and range of acceptable prices. ⚠️ RED FLAG: If <15% strong interest, pivot or refine idea before proceeding.':
    '📊 关键：分析结果 - 计算：(1) 问题频率：每周/每天经历它的百分比，(2) 需求信号：说"绝对会使用"的百分比（需要 ≥15%），(3) 价格范围：可接受价格的中位数和范围。⚠️ 危险信号：如果 <15% 强烈兴趣，在继续之前调整或改进想法。',
  
  '🔍 IMPORTANT: Research 5-10 competitors - For each, document: what they do well, customer complaints (check reviews), pricing model, target customer. Identify your differentiation angle.':
    '🔍 重要：研究 5-10 个竞争对手 - 对于每个，记录：他们做得好的地方，客户投诉（检查评论），定价模型，目标客户。确定您的差异化角度。',
  
  '✅ OPTIONAL: If validation fails (<15% interest) - Use the pivot framework: (1) Change target customer, (2) Adjust solution approach, (3) Solve a different problem, or (4) Try a new idea. Don\'t proceed to building without validation.':
    '✅ 可选：如果验证失败（<15% 兴趣）- 使用转向框架：(1) 更改目标客户，(2) 调整解决方案方法，(3) 解决不同的问题，或 (4) 尝试新想法。不要在没有验证的情况下继续构建。',

  // Have Idea - Build MVP Phase Headers
  '🎯 PHASE 1: SETUP (Days 1-3) - Define scope and prepare environment':
    '🎯 阶段 1：设置（第 1-3 天）- 定义范围并准备环境',
  
  '🏗️ PHASE 2: BUILD (Days 4-12) - Implement core feature only':
    '🏗️ 阶段 2：构建（第 4-12 天）- 仅实现核心功能',
  
  '🚀 PHASE 3: DEPLOY (Days 13-21) - Make it accessible and trackable':
    '🚀 阶段 3：部署（第 13-21 天）- 使其可访问和可跟踪',

  // Have Idea - Build MVP Actions
  '📝 CRITICAL: Define core action - Write "My tool will [INPUT] → [OUTPUT]" with specific examples. Example: "Take a blog post URL → Return 5 social media posts" or "Take a photo → Return outfit suggestions". Include acceptance criteria: what counts as "working"?':
    '📝 关键：定义核心操作 - 用具体示例写出"我的工具将 [输入] → [输出]"。示例："接收博客文章 URL → 返回 5 个社交媒体帖子" 或 "接收照片 → 返回服装建议"。包括验收标准：什么算作"工作"？',
  
  '✂️ CRITICAL: List minimum features - Identify ONE core action. List what to SKIP for v1: user accounts, fancy design, settings pages, multiple features, advanced error handling. Make it work first, make it pretty later.':
    '✂️ 关键：列出最小功能 - 确定一个核心操作。列出 v1 要跳过的内容：用户账户、花哨的设计、设置页面、多个功能、高级错误处理。先让它工作，再让它漂亮。',
  
  '🛠️ IMPORTANT: Choose tech stack - Take the quiz to get personalized recommendation. Options: (A) No-code: Bubble.io, Softr, Glide (faster, less flexible), (B) Code + AI: React/Next.js + Claude/ChatGPT (more control, steeper learning). Choose based on: skill level, budget, timeline, custom logic needs.':
    '🛠️ 重要：选择技术栈 - 参加测验以获得个性化推荐。选项：(A) 无代码：Bubble.io、Softr、Glide（更快，灵活性较低），(B) 代码 + AI：React/Next.js + Claude/ChatGPT（更多控制，学习曲线更陡）。根据以下选择：技能水平、预算、时间表、自定义逻辑需求。',
  
  '⚙️ IMPORTANT: Set up environment - Create new project, install dependencies, test "Hello World" deployment to verify setup works. Use starter templates to save time.':
    '⚙️ 重要：设置环境 - 创建新项目，安装依赖项，测试"Hello World"部署以验证设置有效。使用启动模板以节省时间。',
  
  '📥 CRITICAL: Build input mechanism - Create form/upload for user input (Days 4-6). Keep it simple: basic form fields or file upload. Test that data is captured correctly.':
    '📥 关键：构建输入机制 - 为用户输入创建表单/上传（第 4-6 天）。保持简单：基本表单字段或文件上传。测试数据是否正确捕获。',
  
  '⚙️ CRITICAL: Build processing logic - Implement core functionality (Days 7-9). This is your main value: the transformation from input to output. Use AI assistants (Claude, ChatGPT) to write code faster. Focus on making it work, not perfect.':
    '⚙️ 关键：构建处理逻辑 - 实现核心功能（第 7-9 天）。这是您的主要价值：从输入到输出的转换。使用 AI 助手（Claude、ChatGPT）更快地编写代码。专注于让它工作，而不是完美。',
  
  '📤 CRITICAL: Build output display - Show results to user (Days 10-11). Simple is fine: basic text, list, or table. Make sure users can see and understand the output.':
    '📤 关键：构建输出显示 - 向用户显示结果（第 10-11 天）。简单就好：基本文本、列表或表格。确保用户可以看到并理解输出。',
  
  '🔗 CRITICAL: Connect end-to-end - Test complete input → processing → output flow (Day 12). Verify the entire journey works without errors. This is your "it works!" moment. 🎉':
    '🔗 关键：端到端连接 - 测试完整的输入 → 处理 → 输出流程（第 12 天）。验证整个旅程无错误地工作。这是您的"它工作了！"时刻。🎉',
  
  '🌐 CRITICAL: Deploy online - Put your MVP on the internet (Days 13-14). Use: Vercel (best for Next.js/React), Netlify (great for static sites), Heroku/Railway (good for backend apps), or your no-code platform\'s hosting. Get a public URL that works.':
    '🌐 关键：在线部署 - 将您的 MVP 放到互联网上（第 13-14 天）。使用：Vercel（最适合 Next.js/React），Netlify（非常适合静态网站），Heroku/Railway（适合后端应用），或您的无代码平台的托管。获取一个有效的公共 URL。',
  
  '✅ CRITICAL: Test deployment - Verify anyone with the link can use it (Day 15). Open in incognito mode, test on different browsers, share with a friend. Make sure it actually works for others.':
    '✅ 关键：测试部署 - 验证任何有链接的人都可以使用它（第 15 天）。在隐身模式下打开，在不同浏览器上测试，与朋友分享。确保它对其他人确实有效。',
  
  '📄 CRITICAL: Create landing page - Make a simple page (Days 16-17) with: (1) Clear headline: "What problem does this solve?", (2) Demo: GIF/video showing it working (use Loom + GIF converter), (3) Email signup form (Mailchimp, ConvertKit, or Google Form), (4) "Try It Now" button.':
    '📄 关键：创建登陆页面 - 制作一个简单的页面（第 16-17 天），包含：(1) 清晰的标题："这解决了什么问题？"，(2) 演示：显示其工作原理的 GIF/视频（使用 Loom + GIF 转换器），(3) 电子邮件注册表单（Mailchimp、ConvertKit 或 Google 表单），(4) "立即试用"按钮。',
  
  '📱 IMPORTANT: Make mobile-responsive - Test on desktop, mobile, tablet (Day 18). Most users will view on mobile. Use responsive design or mobile-first frameworks.':
    '📱 重要：使其适应移动设备 - 在桌面、移动设备、平板电脑上测试（第 18 天）。大多数用户将在移动设备上查看。使用响应式设计或移动优先框架。',
  
  '📊 IMPORTANT: Set up analytics - Add Google Analytics or Plausible (Day 19). Track: page views, button clicks, email signups, tool usage. Test that events fire correctly.':
    '📊 重要：设置分析 - 添加 Google Analytics 或 Plausible（第 19 天）。跟踪：页面浏览量、按钮点击、电子邮件注册、工具使用。测试事件是否正确触发。',
  
  '🧪 CRITICAL: End-to-end testing - Test complete user journey (Days 20-21): land on page → watch demo → sign up → use tool. Get 3-5 friends to test and give feedback. Fix critical issues only.':
    '🧪 关键：端到端测试 - 测试完整的用户旅程（第 20-21 天）：登陆页面 → 观看演示 → 注册 → 使用工具。让 3-5 个朋友测试并提供反馈。仅修复关键问题。',

  // Get Early Users - Phase Headers
  '🚀 PHASE 1: SETUP BETA (Days 1-3) - Prepare beta infrastructure and launch materials':
    '🚀 阶段 1：设置测试版（第 1-3 天）- 准备测试版基础设施和发布材料',
  
  '👥 PHASE 2: LAUNCH (Days 4-10) - Recruit beta users and onboard them':
    '👥 阶段 2：发布（第 4-10 天）- 招募测试用户并引导他们',
  
  '📊 PHASE 3: ANALYZE (Days 11-14) - Collect feedback and optimize':
    '📊 阶段 3：分析（第 11-14 天）- 收集反馈并优化',

  // Get Early Users - Actions
  '🚀 CRITICAL: Generate Beta Program Assets - Auto-creates: beta landing page, welcome email sequence, feedback survey, and analytics tracking. This sets up your entire beta infrastructure.':
    '🚀 关键：生成测试版程序资料 - 自动创建：测试版登陆页面、欢迎电子邮件序列、反馈调查和分析跟踪。这将设置您的整个测试版基础设施。',

  // In Progress Stage - Additional actions
  'Step 1: Identify your best marketing channels - Analyze where your current users come from and double down on those channels.':
    '步骤 1：识别您最好的营销渠道 - 分析您当前用户的来源并加倍投入这些渠道。',
  
  'Step 2: Create content marketing strategy - Develop valuable content that attracts your target audience through blogs, videos, or social media.':
    '步骤 2：创建内容营销策略 - 开发有价值的内容，通过博客、视频或社交媒体吸引您的目标受众。',
  
  'Step 3: Set up tracking and analytics - Implement proper tracking to measure which marketing efforts are working best.':
    '步骤 3：设置跟踪和分析 - 实施适当的跟踪以衡量哪些营销工作效果最好。',
};

/**
 * Helper function to get translation for an action text
 */
export function getActionTranslation(text: string): string | undefined {
  return actionTranslations[text];
}
